// TODO: refactor jQuery --> ES
export default class Form {
	constructor(app) {
		this.app = app;
		const self = this;

		const scriptNode = document.querySelector('script[data-sitekey]');
		if(scriptNode === null) {
			console.warn('Found no reCAPTCHA script node');
			return; // no don't need to bind event handlers
		}
		else {
			self.reCAPTCHA_SITEKEY = scriptNode.getAttribute('data-sitekey');
		}

		document.addEventListener('cookie-allowed-convenience-recaptcha', e => {
			function checkForGrecaptcha() {
				if (typeof grecaptcha === 'undefined')
					return setTimeout(checkForGrecaptcha, 100);

				self.newsletter();
				self.downloadCaptcha();
				self.formCaptcha();
			}

			checkForGrecaptcha();
		});

		self.handleCaptchaOverlay();
	}

	/**
	 * Newsletter captcha and spam check
	 */
	newsletter() {
		let self = this;

		let captchaLoaded = false;
		let isDisabled = 2;

		function releaseSubmit() {
			isDisabled -= 1;
			if (isDisabled === 0) {
				$('.js-newsletter-submit').prop('disabled', '');
			}
		}

		$('.js-newsletter-mail, .js-newsletter-engaging').on('change', e => {
			if (!captchaLoaded) {
				grecaptcha.ready(function () {
					grecaptcha.execute(self.reCAPTCHA_SITEKEY, {action: 'newsletter'})
						.then(token => {
							$('.js-newsletter-captcha').val(token);
							releaseSubmit();
						});
				});
				$.ajax({
					type: 'POST',
					url: '/json/skey',
					dataType: 'json',
					success: function (skey) {
						$('.js-newsletter-skey').val(skey);
						releaseSubmit();
					}
				})
				captchaLoaded = true;
			}
		})
	}

	/**
	 * Enable address autocompletion on the given form / inputs.
	 * Use the `address1Field`/street(+no) field as search field.
	 *
	 * If the argument `form` is provided, the other
	 * arguments are ignored. The input-fields will be searched based
	 * on their id.
	 * If all field arguments are provided, these fields will be used.
	 *
	 * @see Docs: https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform#maps_places_autocomplete_addressform-javascript
	 *
	 * @param {HTMLElement=} form The entire form (or a wrapping node), if inputFields will be auto-detected
	 * @param {HTMLElement=} address1Field The address1Field (street + no if
	 * @param {HTMLElement=} streetNumberField The address1Field (street + no if streetNumberField is omitted,
	 *                                         otherwise only the street)
	 * @param {HTMLElement=} address2Field The additional address input (for e.g. the appartment)
	 * @param {HTMLElement=} zipCodeField The zip / postal code input
	 * @param {HTMLElement=} cityField The city input
	 * @param {HTMLElement=} countryField The country input
	 * @param {Object=} options Options for the autocomplete widget
	 * @returns {Promise<google.maps.places.Autocomplete>} The created autocomplete instance.
	 *
	 * @throws {TypeError} In case of an illegal amount of arguments. Must be 1 xor 5.
	 */
	static addressAutocomplete({
								   form,
								   address1Field,
								   streetNumberField,
								   address2Field,
								   zipCodeField,
								   cityField,
								   countryField,
								   options = null
							   }) {
		// static addressAutocomplete(formOrAddress1Field, options = null, address2Field, zipCodeField, cityField, countryField) {
		if (form) {
			if (address1Field || streetNumberField || address2Field || zipCodeField || cityField || countryField) {
				throw new TypeError('form and fields are exclusive.');
			}
			address1Field = form.querySelector('[id*="street_name"]') || form.querySelector('[id*="street"]');
			streetNumberField = form.querySelector('[id*="street_number"]');
			address2Field = form.querySelector('[id*="address_add"]');
			zipCodeField = form.querySelector('[id*="zip"]');
			cityField = form.querySelector('[id*="city"]');
			countryField = form.querySelector('[id*="country"]');
		} else if (!address1Field) {
			throw new TypeError(`No or invalid value '${address1Field}' for address1Field.`)
		} else if (!zipCodeField) {
			throw new TypeError(`No or invalid value '${zipCodeField}' for zipCodeField.`)
		} else if (!cityField) {
			throw new TypeError(`No or invalid value '${cityField}' for cityField.`)
		} else if (!countryField) {
			throw new TypeError(`No or invalid value '${countryField}' for countryField.`)
		}

		function enableAutocomplete() {
			const autocomplete = new google.maps.places.Autocomplete(address1Field, {
				fields: ['address_components'],
				types: ['address'],
				...options,
			});
			autocomplete.addListener('place_changed', fillInAddress.bind(this, autocomplete));
			return autocomplete;
		}

		function fillInAddress(autocomplete) {
			// Get the place details from the autocomplete object.
			const place = autocomplete.getPlace();
			let street = '';
			let streetNumber = '';
			let postcode = '';

			// Get each component of the address from the place details,
			// and then fill-in the corresponding field on the form.
			// place.address_components are google.maps.GeocoderAddressComponent objects
			// which are documented at http://goo.gle/3l5i5Mr
			for (const component of place.address_components) {
				// console.debug('component:', component)
				const componentType = component.types[0];

				switch (componentType) {
					case 'street_number':
						streetNumber = component.long_name;
						break;

					case 'route':
						street = component.long_name;
						break;

					case 'postal_code':
						postcode = `${component.long_name}${postcode}`;
						break;

					case 'postal_code_suffix':
						postcode = `${postcode}-${component.long_name}`;
						break;

					case 'locality':
						cityField.value = component.long_name;
						break;

					case 'country':
						countryField.value = component.short_name.toLowerCase();
						countryField.dispatchEvent(new Event('change', {'bubbles': true}));
						break;
				}
			}

			if (streetNumberField) {
				// we have an extra field for the street number
				address1Field.value = street;
				streetNumberField.value = streetNumber;
			} else {
				address1Field.value = `${street} ${streetNumber}`;
			}
			zipCodeField.value = postcode;
			zipCodeField.dispatchEvent(new Event('keyup', {'bubbles': true}));

			// After filling the form with address components from the Autocomplete
			// prediction, set cursor focus on the second address line to encourage
			// entry of subpremise information such as apartment, unit, or floor number.
			// If no street number has been entered, set the focus to this field instead.
			if (!streetNumber && streetNumberField) streetNumberField.focus()
			else if (address2Field) address2Field.focus();
		}

		return new Promise(function (resolve, reject) {
			function untilReady() {
				if(typeof google === 'undefined' || typeof google.maps === 'undefined') {
					return document.querySelector('.js-script-maps').addEventListener('load', untilReady);
				}
				return resolve(enableAutocomplete());
			}
			function checkConsent(allowedCookies) {
				if (allowedCookies.includes('convenience-address-autocomplete')) {
					resolve(untilReady());
				} else {
					const onConsent = e => {
						// meanwhile the user accepted the cookies
						document.removeEventListener('cookie-allowed-convenience-address-autocomplete', onConsent);
						resolve(untilReady());
					}
					document.addEventListener('cookie-allowed-convenience-address-autocomplete', onConsent);
					// reject('Cookies not allowed'); // TODO: shall we reject here? (or stay pending for a cookie consent change)
				}
			}

			if (app.cookieManager === undefined) { // cookieManager not initiated, let's wait for it
				document.addEventListener('cookie-manager-ready', e => {
					checkConsent(e.detail.allowedCookies)
				})
			} else {
				checkConsent(app.cookieManager.allowedCookies)
			}
		});
	}

	/**
	 * Return the bounds of Europe for address autocompletion.
	 * @return {{east: number, south: number, north: number, west: number}}
	 * @constructor
	 */
	static get EUROPE_BOUNDS() {
		return {
			north: 70.927722,
			south: 36.263893,
			east: 35.667032,
			west: -24.222222,
		};
	}

	/**
	 * Captcha Gateway for downloads
	 * Load token and submit form
	 */
	downloadCaptcha() {
		let self = this;

		if (!$('.js-downloadCaptchaForm').length) return;

		grecaptcha.ready(function () {
			grecaptcha.execute(self.reCAPTCHA_SITEKEY, {action: 'download'})
				.then(token => {
					$('.js-downloadCaptchaForm .js-g-recaptcha-response').val(token);
					$('.js-downloadCaptchaForm').submit();
				});
		});
	}

	/**
	 * Load captcha token into form inputs
	 */
	formCaptcha() {
		let self = this;

		function fetchToken($input) {
			grecaptcha.ready(function () {
				grecaptcha.execute(self.reCAPTCHA_SITEKEY, {action: 'form'})
					.then(token => {
						$input.val(token);
						setTimeout(fetchToken, (2 * 60 - 10) * 1000, $input);
					});
			});
		}


		$('.js-reCAPTCHAv3').each((i, elem) => {
			fetchToken($(elem));
		})
	}

	/**
	 * Remove captcha overlay hint when reCAPTCHA cookies are not allowed
	 */
	handleCaptchaOverlay() {
		// TODO: replace by `js-cookie-extra-inquiry`
		document.addEventListener('cookie-allowed-convenience-recaptcha', e => {
			$('.js-captcha-overlay').remove();
		})
	}
}
